module.exports = __webpack_public_path__ + "img/sa-regions.47968abf.png";